import React from 'react';

const StepIndicator = ({ current }) => {
  const steps = ["Create Items", "Send to Parties", "Collect Rates", "Compare & Finalize"];

  return (
    <div className="d-flex align-items-center flex-wrap mb-4">
      {steps.map((s, i) => {
        const done = i < current;
        const active = i === current;

        return (
          <React.Fragment key={i}>
            <div className={`d-flex align-items-center py-2 px-3 mb-2 rounded-3 me-2`} style={{
              backgroundColor: done ? 'rgba(52, 211, 153, 0.1)' : active ? 'rgba(249, 115, 22, 0.1)' : 'transparent',
              borderColor: done ? '#34d399' : active ? '#f97316' : 'transparent'
            }}>
              <div className={`rounded-circle d-flex align-items-center justify-content-center me-2`} style={{
                width: '24px',
                height: '24px',
                fontSize: '12px',
                fontWeight: '800',
                backgroundColor: done ? '#34d399' : active ? '#f97316' : '#e9ecef',
                color: done || active ? '#fff' : '#6c757d'
              }}>
                {done ? "✓" : i + 1}
              </div>
              <span style={{
                fontSize: '13px',
                fontWeight: '600',
                color: done ? '#34d399' : active ? '#f97316' : '#6c757d'
              }}>{s}</span>
            </div>
            {i < steps.length - 1 && (
              <div className="mx-2 d-none d-md-block" style={{ width: '30px', height: '2px', backgroundColor: '#e9ecef' }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
